import moment from "moment";

export const getDateDescription = (givenDate) => {
  const currentDate = moment().startOf("day");
  const yesterday = moment().subtract(1, "days").startOf("day");

  givenDate = moment(givenDate);

  // Check if given date is today
  if (givenDate.isSame(currentDate, "day")) {
    return "Today";
  }
  // Check if given date is yesterday
  else if (givenDate.isSame(yesterday, "day")) {
    return "Yesterday";
  }
  // Return the actual date
  else {
    // Format the date as desired
    return givenDate.format("YYYY-MM-DD");
  }
};
